export default "__VITE_ASSET__Omhq48VuhIW51vhz4rkajA__"